import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "row justify-content-center align-items-center m-0" }
const _hoisted_3 = { class: "card-body p-md-4 px-0 py-2" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "bg-image hover-overlay" }
const _hoisted_6 = ["alt", "src"]
const _hoisted_7 = {
  class: "mask overlay d-flex align-items-center justify-content-center text-light card-img",
  style: {"background-color":"rgba(0, 0, 0, 0.6)"}
}

import {
        MDBCol,
        MDBIcon,
    } from "mdb-vue-ui-kit";
    import { ref } from "vue";
    import "linkifyjs/lib/linkify-string";
    import { decodeHtml } from "@/functions/utility";

    import { Static } from 'runtypes';
    import { Article } from '@/types/runtypes/article';

    // define props
    interface Props {
        article: Static<typeof Article>
    }
    
export default /*#__PURE__*/_defineComponent({
  props: {
    article: null
  },
  setup(__props: any) {

const { article} = __props as {
        article: Static<typeof Article>
    }

    

    const imgExpand = ref(false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(MDBCol), {
        col: "12",
        lg: __props.article.info.publicSquare.package.image != '' && imgExpand.value == false ? '8' : '12'
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: "card-text",
              innerHTML: _unref(decodeHtml)(__props.article.info.publicSquare.package.description)
            }, null, 8, _hoisted_4)
          ])
        ]),
        _: 1
      }, 8, ["lg"]),
      (__props.article.info.publicSquare.package.image != '')
        ? (_openBlock(), _createBlock(_unref(MDBCol), {
            key: 0,
            col: "12",
            lg: "4",
            class: _normalizeClass(["p-2", imgExpand.value ? 'col-lg-12' : ''])
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("img", {
                  class: _normalizeClass(imgExpand.value ? 'card-img' : 'card-img limit-height'),
                  alt: __props.article.provenance.publisher.name,
                  src: __props.article.info.publicSquare.package.image,
                  loading: "lazy"
                }, null, 10, _hoisted_6),
                _createElementVNode("button", {
                  class: "d-none d-lg-block d-xl-block border-0",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (imgExpand.value = !imgExpand.value))
                }, [
                  _createElementVNode("div", _hoisted_7, [
                    (imgExpand.value)
                      ? (_openBlock(), _createBlock(_unref(MDBIcon), {
                          key: 0,
                          icon: "compress",
                          iconStyle: "fas",
                          size: "3x"
                        }))
                      : (_openBlock(), _createBlock(_unref(MDBIcon), {
                          key: 1,
                          icon: "expand",
                          iconStyle: "fas",
                          size: "lg"
                        }))
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["class"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})